import React from 'react';
import { useMutation } from '@apollo/client';
import { DrawerNavigationProp } from '@react-navigation/drawer';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import Snackbar from '~/components/Snackbar';
import { CREATE_CAMPAIGN } from '~/data/operations/campaign';
import { CreateCampaignInput } from '~/data/types/graphql';
import { AdminStackParamList, AdsStackParamList } from '~/navigation/types';
import { formattedDateTime } from '~/utils/dates';
import AddCampaignLayout from './layout';

type AddCampaignNavProp = StackNavigationProp<AdsStackParamList, 'AddCampaign'>;

export default function AddCampaign(): JSX.Element {
  const { openDrawer } =
    useNavigation<DrawerNavigationProp<AdminStackParamList>>();

  const navigation = useNavigation<AddCampaignNavProp>();

  const [createCampaign] = useMutation(CREATE_CAMPAIGN);

  const onCreateCampaign = async ({
    name,
    utm,
    startDate,
    endDate,
    type,
    customer,
    orderId,
  }: CreateCampaignInput) => {
    try {
      const { data } = await createCampaign({
        variables: {
          input: {
            name,
            utm,
            startDate: formattedDateTime(startDate.dateString),
            endDate: formattedDateTime(endDate.dateString),
            type,
            customer,
            orderId,
          },
        },
      });

      if (data !== null) {
        navigation.navigate('EditAd', {
          id: data?.createCampaign?.campaign?.id as string,
        });
      }
    } catch (e) {
      if (e instanceof Error) {
        Snackbar.show(e.message);
      }
    }
  };
  return (
    <AddCampaignLayout
      onBack={() => navigation.goBack()}
      openDrawer={openDrawer}
      onCreateCampaign={onCreateCampaign}
    />
  );
}
